<mat-form-field>
    <mat-label>{{label}}</mat-label>
    <mat-select [formControl]="fontControl" (selectionChange)="onBlur()">
      <mat-option *ngFor="let font of fonts" [value]="font">
        {{font}}
      </mat-option>
    </mat-select>
    <mat-hint>To see what the fonts look like, go to the <a href="https://fonts.google.com/" target="_blank">Google Fonts website</a></mat-hint>
</mat-form-field>